/* Funeral-director commission helpers shared by the director forms, the
 * work-order forms and the review screen.
 *
 * The server owns the maths: the client sends only the boolean
 * `apply_fd_commission`, the server reads the rate off the director and
 * snapshots it onto the order. These helpers validate the rate field and
 * preview the figure the server will store.
 *
 * Contract: Rays-Florist-Server/docs/frontend-commission-integration.md */

/** "" → 0, "12.5" → 12.5, anything non-numeric or outside 0–100 → null. */
export function commissionPctOf(raw) {
  if (raw === undefined || raw === null || String(raw).trim() === "") return 0;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0 || n > 100) return null;
  return Math.round(n * 100) / 100;
}

export const pctLabel = (value) => `${Number(value) || 0}%`;

/** The commission a saved work order carries. Orders created before the
    feature have no `fd_commission` at all, which reads as off. */
export function commissionOf(order) {
  const c = (order && order.fd_commission) || {};
  return {
    apply: Boolean(c.apply),
    pct: Number(c.pct) || 0,
    fd_id: c.fd_id || null,
    fd_code: c.fd_code || "",
    snapshot_at: c.snapshot_at || null,
  };
}

/** The server's formula per commissioned Funeral work order, rounded to
    cents: (total_price + delivery_fee) × pct / 100 — the order total as the
    customer pays it, GST included. (It was the ex-GST total until 29 Sep
    2026; the client asked for the "Total" line.) */
export function estimateFdCommission(totalPrice, deliveryFee, pct) {
  const base = (Number(totalPrice) || 0) + (Number(deliveryFee) || 0);
  const rate = (Number(pct) || 0) / 100;
  return Math.round(base * rate * 100) / 100;
}
